export default __webpack_public_path__ + "images/src/assets/img/Call center.png";